import React, { useCallback, useMemo, useRef } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  ResponsiveContainer,
} from "recharts";
import styles from "./Style.module.css";
import { Typography } from "@mui/material";
import NoDataFound from "../../../ProgramDashboard/component/NoDataFound/NoDataFound";
import capitalizeFirstLetter from "../../../../hooks/CommonFunction";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { FileDownloadOutlined } from "@mui/icons-material";
import html2canvas from "html2canvas";

const renderCustomizedLabel = (props) => {
  const { x, y, width, value } = props;

  if (!value) return null;

  return (
    <foreignObject x={x + width / 2 - 25} y={y - 55} width={50} height={50}>
      <img
        src={value}
        alt=""
        width="50"
        height="50"
        crossOrigin="anonymous"
        style={{ borderRadius: "50%" }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "/fallback.png"; // optional fallback
        }}
      />
    </foreignObject>
  );
};

const PetAdoptedChart = ({
  data = [],
  title,
  isExpand = false,
  isImgDownload = false,
  onExpand,
}) => {
  const chartRef = useRef(null);

  const chartData = useMemo(() => {
    return data?.map((item) => ({
      name: item?.pet?.name,
      adoption: item?.adoption,
      img: item?.pet?.image,
    }));
  }, [data]);

  const handleDownload = useCallback(() => {
    if (!chartRef.current) return;

    html2canvas(chartRef.current, { scale: 2 }).then((canvas) => {
      const link = document.createElement("a");
      link.download = "map-chart.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  }, [title]);

  return (
    <div className={styles.chartContainer}>
      <div className={styles.dFlex}>
        <Typography variant={"h5"} className={"heading"}>
          {title}
        </Typography>
        {isExpand && (
          <OpenInNewIcon
            onClick={onExpand}
            color="primary"
            size="small"
            className={styles.expandIcon}
          />
        )}
        {isImgDownload && (
          <FileDownloadOutlined
            onClick={handleDownload}
            color="primary"
            fontSize="small"
            className={styles.downloadIcon}
          />
        )}
      </div>
      {chartData?.length > 0 ? (
        <div style={{ width: "100%", height: 400 }}>
          <ResponsiveContainer>
            <BarChart
              data={chartData}
              ref={chartRef}
              margin={{ top: 60, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                tickFormatter={(value) => capitalizeFirstLetter(value)}
              />
              <YAxis />
              <Tooltip cursor={{ fill: "transparent" }} />
              <Bar dataKey="adoption" fill="#004DC1" barSize={30}>
                <LabelList dataKey="img" content={renderCustomizedLabel} />
                <LabelList
                  dataKey={"adoption"}
                  content={({ x, y, width, height, value }) => {
                    if (!value) return null;
                    return (
                      <text
                        x={x + width / 2}
                        y={y + height / 2}
                        fill="#fff"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fontSize={12}
                        fontWeight="bold"
                      >
                        {value}
                      </text>
                    );
                  }}
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default PetAdoptedChart;
